/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Status_Starting_PublishInputs */

const en_work_order_publish_status_starting_publish = /** @type {(inputs: Work_Order_Publish_Status_Starting_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting Publish`)
};

const fr_work_order_publish_status_starting_publish = /** @type {(inputs: Work_Order_Publish_Status_Starting_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrage de la publication`)
};

const de_work_order_publish_status_starting_publish = /** @type {(inputs: Work_Order_Publish_Status_Starting_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichung starten`)
};

const it_work_order_publish_status_starting_publish = /** @type {(inputs: Work_Order_Publish_Status_Starting_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizio pubblicazione`)
};

const ru_work_order_publish_status_starting_publish = /** @type {(inputs: Work_Order_Publish_Status_Starting_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начало публикации`)
};

const es_work_order_publish_status_starting_publish = /** @type {(inputs: Work_Order_Publish_Status_Starting_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando Publicación`)
};

const zh_cn2_work_order_publish_status_starting_publish = /** @type {(inputs: Work_Order_Publish_Status_Starting_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始发布`)
};

const ja_work_order_publish_status_starting_publish = /** @type {(inputs: Work_Order_Publish_Status_Starting_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開を開始`)
};

const hi_work_order_publish_status_starting_publish = /** @type {(inputs: Work_Order_Publish_Status_Starting_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकाशन शुरू करना`)
};

const pt_pt2_work_order_publish_status_starting_publish = /** @type {(inputs: Work_Order_Publish_Status_Starting_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começando a publicar`)
};

/**
* | output |
* | --- |
* | "Starting Publish" |
*
* @param {Work_Order_Publish_Status_Starting_PublishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_status_starting_publish = /** @type {((inputs?: Work_Order_Publish_Status_Starting_PublishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Status_Starting_PublishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_status_starting_publish(inputs)
	if (locale === "de") return de_work_order_publish_status_starting_publish(inputs)
	if (locale === "it") return it_work_order_publish_status_starting_publish(inputs)
	if (locale === "ru") return ru_work_order_publish_status_starting_publish(inputs)
	if (locale === "es") return es_work_order_publish_status_starting_publish(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_status_starting_publish(inputs)
	if (locale === "ja") return ja_work_order_publish_status_starting_publish(inputs)
	if (locale === "hi") return hi_work_order_publish_status_starting_publish(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_status_starting_publish(inputs)
	return en_work_order_publish_status_starting_publish(inputs)
});